const selectorTabbable = `
  a[href], area[href], input:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true],
  fil-accordion-item,
  fil-button-group,
  fil-button,
  fil-checkbox,
  fil-date-picker,
  fil-dropdown,
  fil-text-input,
  fil-link,
  fil-modal,
  fil-modal-footer,
  fil-modal-content,
  fil-select,
  fil-radio,
  fil-slider,
  fil-tab,
  fil-textarea,
  fil-toggle,
  fil-tooltip`;

function tryFocusElems(elems, reverse) {
  if (!elems) {
    return false;
  }

  if (!reverse) {
    for (let i = 0; i < elems.length; ++i) {
      const elem = elems[i];
      elem.focus();
      if (elem.ownerDocument && elem.ownerDocument.activeElement === elem) {
        return true;
      }
    }
  } else {
    for (let i = elems.length - 1; i >= 0; --i) {
      const elem = elems[i];
      elem.focus();
      if (elem.ownerDocument && elem.ownerDocument.activeElement === elem) {
        return true;
      }
    }
  }
  return false;
}

const PRECEDING = Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS;
const FOLLOWING = Node.DOCUMENT_POSITION_FOLLOWING | Node.DOCUMENT_POSITION_CONTAINED_BY;

// Because we're going to have a bunch of exports
export { selectorTabbable, tryFocusElems, PRECEDING, FOLLOWING };
